// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UniqueSellingPoint{border:1px solid #c6def6;border-radius:.25rem;font-family:\"Raleway\",Arial,sans-serif;text-align:center}.UniqueSellingPoint__iconWrapper{display:inline-block;float:none;height:auto;margin:0 0 1.5rem}@media(min-width:768px){.UniqueSellingPoint__iconWrapper>svg{height:2.5rem}}.UniqueSellingPoint__content{float:none;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
